import type { TracksStore } from '@/shared/store/tracks.store.tsx'
import type { AudioFormInput } from '../../../../audio-form/data/dto/audio-form-input.ts'
import { mapMediaFilesToAudioformLayers } from './map-media-files-to-audioform-layers.ts'
import { mapSoundDesignsToAudioformLayers } from './map-sound-designs-to-audioform-layers.ts'
import { mapVoicesAndSpeechesToAudioformLayers } from './map-voices-and-speeches-to-audioform-layers.ts'
import { mapMediaFileClipsToAssets } from './map-media-file-clips-to-assets.ts'
import { mapSoundDesignClipsToAssets } from './map-sound-design-clips-to-assets.ts'
import { mapSoundEffectClipsToAssets } from './map-sound-effect-clips-to-assets.ts'
import { mapSoundEffectsToAudioformLayers } from './map-sound-effects-to-audioform-layers.ts'
import { mapVoiceAndSpeechClipsToAssets } from './map-voice-and-speech-clips-to-assets.ts'

export const mapTracksStoreToAudioForm = (
  tracksStore: TracksStore
): AudioFormInput => {
  const audioFormAssets = {
    ...mapVoiceAndSpeechClipsToAssets(tracksStore),
    ...mapSoundDesignClipsToAssets(tracksStore),
    ...mapMediaFileClipsToAssets(tracksStore),
    ...mapSoundEffectClipsToAssets(tracksStore),
  }

  const layers = [
    mapVoicesAndSpeechesToAudioformLayers(tracksStore),
    mapSoundDesignsToAudioformLayers(tracksStore),
    mapMediaFilesToAudioformLayers(tracksStore, audioFormAssets),
    mapSoundEffectsToAudioformLayers(tracksStore, audioFormAssets),
  ].flatMap((layerGroup) =>
    layerGroup.filter((layer) => layer.clips.length > 0)
  )

  return {
    header: {
      version: '2',
    },
    assets: audioFormAssets,
    production: {
      arrangement: {
        usePlaybackGainHints: false,
        sections: [
          {
            layers,
          },
        ],
      },
      masteringPreset: 'balanced',
    },
    delivery: {
      loudnessPreset: 'spotify',
      encoderPreset: 'wav',
      public: false,
    },
  }
}
